import { useState, useRef } from "react";

import { HTTPErrorCallback } from "Helpers/Error";

import UseAppConfig from "Hooks/UseAppConfig";
import UseAuth from "Hooks/UseAuth";
import UseNotification from "Hooks/UseNotification";
import UseServices from "Hooks/UseServices";

import ForgotPassword from "./ForgotPassword";
import StepLogin from "./StepLogin";
import StepPassword from "./StepPassword";
import * as S from "./styles";

const Login = () => {
  const { api } = UseServices();
  const { storeToken } = UseAuth();
  const { showNotification } = UseNotification();
  const { appConfig, loadingConfig } = UseAppConfig();

  const [loading, setLoading] = useState(false);

  const [reCaptchaToken, setReCaptchaToken] = useState(null);
  const turnstileRef = useRef(null);

  const [loginStep, setLoginStep] = useState("login");
  const [login, setLogin] = useState(null);

  const getComponent = () => {
    switch (loginStep) {
      case "login":
        return (
          <StepLogin
            loading={loading}
            validateLogin={validateLogin}
            appConfig={appConfig}
            loadingConfig={loadingConfig}
          />
        );
      case "password":
        return (
          <StepPassword
            loading={loading}
            switchStep={switchStep}
            setReCaptchaToken={setReCaptchaToken}
            turnstileRef={turnstileRef}
            submitData={submitData}
            setLoginStep={setLoginStep}
          />
        );
      case "forgotPassword":
        return (
          <ForgotPassword
            email={login}
            loading={loading}
            setLoading={setLoading}
            setLoginStep={setLoginStep}
          />
        );
      default:
        return <StepLogin loading={loading} validateLogin={validateLogin} />;
    }
  };

  const submitData = (data) => {
    if (reCaptchaToken) {
      data.captcha_token = reCaptchaToken;
      data.captcha_date = new Date();
    } else {
      return showNotification(
        "warning",
        "Atenção!",
        "É necessário confirmar que você não é um robô.",
      );
    }

    data.login = login;

    setLoading(true);

    api
      .post("/sessions/login", data)
      .then((response) => {
        storeToken(response.data.token, true);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setReCaptchaToken(null);
        if (turnstileRef.current) {
          turnstileRef.current.reset();
        }
        HTTPErrorCallback(error);
      });
  };

  const switchStep = () => {
    switch (loginStep) {
      case "login":
        setLoginStep("password");
        break;
      case "password":
      default:
        setLoginStep("login");
        break;
    }
  };

  const validateLogin = ({ login }) => {
    if (!login)
      return showNotification("warning", "Atenção!", "Informe seu login!");

    setLogin(login);
    switchStep();
  };

  return <S.Container>{getComponent()}</S.Container>;
};

export default Login;
